import React, { ReactElement, useState } from 'react';
import classnames from 'classnames';
import { IconButton } from '../IconButton';
import { Icon, IconNames } from '../Icon';
import styles from './index.module.css';

export type IconColours = 'danger' | 'info' | 'muted' | 'success';

export type ToastProps = {
  className?: string;
  iconColour?: IconColours;
  iconName?: IconNames;
  iconTestId?: string;
  message: string;
  onClose?: VoidFunction;
  title: string;
  logRef?: string;
};

export function Toast({
  className,
  iconColour,
  iconName,
  iconTestId,
  logRef,
  message,
  onClose,
  title,
}: ToastProps): ReactElement {
  const rootClasses = classnames('toast', styles.root, className);
  const iconClasses = classnames('toast__icon', {
    [`text-${iconColour}`]: iconColour,
  });
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyToClipBoard = () => {
    setIsCopied(true);
    navigator.clipboard.writeText(logRef!);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  return (
    <div className={rootClasses}>
      {iconName && (
        <Icon className={iconClasses} name={iconName} testId={iconTestId} />
      )}
      <div className="toast__body">
        <div className="toast__title">{title}</div>
        <div className="toast__message">{message}</div>
        {logRef && (
          <span className={styles.logRef}>
            <div data-testid={`logref-${logRef}`}>
              Ref: {logRef}
              <span className={styles.clone}>
                {isCopied ? (
                  <IconButton icon="check" colour="link" size="large" />
                ) : (
                  <IconButton
                    icon="clone"
                    colour="link"
                    size="large"
                    onClick={() => handleCopyToClipBoard()}
                    title="Copy to clipboard"
                    aria-label="Copy to clipboard"
                  />
                )}
              </span>
            </div>
          </span>
        )}
      </div>
      {onClose && (
        <span className={styles.close}>
          <IconButton
            icon="close"
            colour="link"
            size="large"
            onClick={onClose}
            aria-label="Dismiss toast"
          />
        </span>
      )}
    </div>
  );
}
